import styled from 'styled-components';
import { primitives } from '@veneer/primitives';

export const CARDS_GAP = primitives.layout.size6;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  padding: 0;
`;

export const Cards = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: ${primitives.layout.size6}px;
  justify-content: flex-start;
  overflow-x: auto;
  max-width: fit-content;
  margin-top: 40px;
  margin-bottom: ${primitives.layout.size5}px;

  /* Hide scrollbar */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */

  &::-webkit-scrollbar {
    display: none; /* WebKit */
  }
`;

export const CardsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;
